<template>
  <div class="wrapper">
    <!-- 头部 -->
    <app-header></app-header>
    <!-- 主体部分 -->
    <app-main></app-main>
    <!-- 底部 -->
    <app-footer></app-footer>
    <!-- 返回顶部 -->
    <app-back-top></app-back-top>
  </div>
</template>
<script>
import Header from './header'
import Main from './main'
import Footer from './footer'
import BackTop from './backTop'
export default {
  components: {
    'app-header': Header,
    'app-main': Main,
    'app-footer': Footer,
    'app-back-top': BackTop
  }
}
</script>
